import { render, staticRenderFns } from "./TractDetail.vue?vue&type=template&id=65152576&"
import script from "./TractDetail.vue?vue&type=script&lang=js&"
export * from "./TractDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports